import React from "react";
import { Form, Placeholder } from "react-bootstrap";
import { Button } from "../../Components/CustomComponents";

const PlatformFeeFormSkeleton = () => {
  return (
    <Form>
      {/* Consumer Platform Fee */}
      <Placeholder as="h6" animation="wave" className="mb-1">
        <Placeholder xs={4} />
      </Placeholder>
      <Placeholder
        as="div"
        animation="wave"
        className="rounded w-100 mb-3"
        style={{ height: "38px" }}
      />

      {/* Agent Platform Fee */}
      <Placeholder as="h6" animation="wave" className="mb-1">
        <Placeholder xs={4} />
      </Placeholder>
      <Placeholder
        as="div"
        animation="wave"
        className="rounded w-100 mb-3"
        style={{ height: "38px" }}
      />

      {/* Brokerage Access Fee */}
      <Placeholder as="h6" animation="wave" className="mb-1">
        <Placeholder xs={5} />
      </Placeholder>
      <Placeholder
        as="div"
        animation="wave"
        className="rounded w-100 mb-3"
        style={{ height: "38px" }}
      />

      {/* Button */}
      <Placeholder.Button variant="primary" xs={2} className="mt-3" />
    </Form>
  );
};

export default PlatformFeeFormSkeleton;
